
import $ from 'jquery';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { Fancybox, Carousel, Panzoom } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox.css";


const aos = (() => {
    const defaultAos = () => {
        AOS.init();
    };
  
    const init = () => {
        defaultAos();
    };
  
    return {
      init,
    };
  })();
  
  export default aos;
  